import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from 'fe-appdir-lib-theme';

const PROP_TYPES = {
  heading: PropTypes.string.isRequired,
  ctas: PropTypes.func.isRequired,
};

const Section = styled.section`
  margin-top: 64px;
  padding: ${theme.padding2x} 15px;
  background: ${theme.colorBlack};
  text-align: center;

  @media (min-width: ${theme.breakpointMd}) {
    margin-top: 96px;
  }
`;

const Wrapper = styled.div`
  max-width: ${theme.breakpointXs};
  margin: 0 auto;

  @media (min-width: ${theme.breakpointSm}) {
    max-width: ${theme.breakpointSm};
  }

  @media (min-width: ${theme.breakpointMd}) {
    max-width: ${theme.breakpointMd};
  }

  @media (min-width: ${theme.breakpointLg}) {
    max-width: ${theme.breakpointLg};
  }

  @media (min-width: ${theme.breakpointXl}) {
    max-width: ${theme.breakpointXl};
  }

  @media (min-width: ${theme.breakpointXxl}) {
    max-width: ${theme.breakpointXxl};
  }
`;

const H2 = styled.h2`
  font-family: ${theme.fontFamilyPrimary};
  font-size: ${theme.fontSizeXxl};
  font-weight: ${theme.fontWeightNormal};
  color: ${theme.colorWhite};

  @media (min-width: ${theme.breakpointMd}) {
    font-size: ${theme.fontSizeH2};
  }
`;

const CtaContainer = styled.div`
  margin: ${theme.margin2x} 0;
  text-align: center;

  // Whatever gets rendered should be spaced out
  & > * {
    margin: 0 ${theme.marginHalf};

    @media (max-width: ${theme.breakpointMd}) {
      margin: ${theme.marginHalf};
    }
  }

  @media (max-width: ${theme.breakpointMd}) {
    display: flex;
    flex-direction: column;
  }
`;

const CtaSection = ({ heading, ctas }) => (
  <Section>
    <Wrapper>
      <H2>{heading}</H2>
      <CtaContainer>{ctas()}</CtaContainer>
    </Wrapper>
  </Section>
);

CtaSection.propTypes = PROP_TYPES;
CtaSection.displayName = 'CtaSection';

export default CtaSection;
